module.exports = __webpack_public_path__ + "img/SER-i-1-II.7fe1b754.png";